module.exports = __webpack_public_path__ + "static/media/vault-logo-white.93a54820.svg";